<template>
  <div>
    <div class="show-for-sr" aria-live="polite" aria-atomic="true">Step {{ currentStep }} of {{ stepNames.length }}</div>
    <ol class="c-steps" aria-label="Progress completion">
      <li v-for="(step, index) in stepNames" class="c-steps-step" 
          v-bind:aria-current="currentStep === index+1 ? 'step' : null" 
          v-bind:class="currentStep > index+1 ? 'is-complete' : null">

        <template v-if="currentStep <= index+1 || status == 'COMPLETE' || status == 'CANCELLED' || index > 0 && action == 'CANCEL'">
          {{ step }}
        </template>
        <a v-else href="#" v-on:click.stop.prevent="$emit('go-to-step', index+1)" v-cloak>
          <span class="show-for-sr">{{ srLabel }}</span> {{ step }}
        </a>

      </li>
    </ol>
  </div>
</template>

<script>
import Vue from 'vue';

export default {
  props: [
    'currentStep',
    'status',
    'action',
    'stepNames',
    'srLabel'
  ],
  data () {
    return {}
  },
  watch: {
    // Manage focus on step containers
    currentStep () {
      const el = document.querySelector(`[data-step="${this.currentStep}"]`),
            heading = el.querySelector('h2');

      heading.setAttribute('tabindex', -1)
      
      Vue.nextTick(() => {
        heading.focus();
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/js/pickup/components/_pickup-steps.vue